// @ts-nocheck
import SignatureTemplateManageComponent from '@/PageComponents/Signature/SignatureTemplateManageComponent';
import Breadcrumbs from '@/components/breadcrumbs';
import ConfirmAction from '@/components/modals/confirm-action';
import SettingsMenu from '@/components/settings/menu';
import { SignatureTemplate } from '@/interfaces/api/models';
import constants from '@/utils/constants';
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import helper from '@/utils/helper';
import { Box, Card, Flex } from '@mantine/core';
import { useRouter } from 'next/router';
import { FC, useContext, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router'

const EditSignatureTemplate: FC = () => {

    const router = useRouter();
    const { id } = router.query as any; // TODO(tanstack-router): verify router.query → useParams/useSearch

    let currPath = '';
    if (router) {
        currPath = router.asPath;
    }

    const [signatureTemplate, setSignatureTemplate] = useState<SignatureTemplate | null>(null);
    const [isDirty, setIsDirty] = useState(false);
    const [confirmOptions, setConfirmOptions] = useState({ ...helper.initialiseConfirmOptions() });

    helper.preventRouteChange(isDirty, setIsDirty, setConfirmOptions, null);

    return (<>
        {/*<Box
            mt={'sm'}
            px={'md'}
            mb={0}
            pb={0}
            style={(theme) => ({ borderBottom: `var(--mantine-color-gray-2) 2px solid` })}
        >
            <Box my={'md'}>
                <Breadcrumbs
                    crumbs={[
                        { text: 'Settings', link: '', suppressLink: true },
                        { text: 'Signature Templates', link: '/settings/signaturetemplate/list' },
                        { text: signatureTemplate?.Name, link: '' }
                    ]}
                />
            </Box>
        </Box>*/}
        <Flex
            bg={'gray.1'}
            p={'sm'}
            style={{ justifyContent: "space-between" }}
        >
            <SettingsMenu urlPath={currPath} hideShadow={true} />
            <Card
                bg={'white'}
                p={'md'}
                radius={'md'}
                w={"100%"}
            >
                <SignatureTemplateManageComponent
                    id={id}
                    onChange={setSignatureTemplate}
                    dirtyChanged={setIsDirty}
                    backButton={{
                        label: "Back to List"
                    }}
                />

            </Card>
        </Flex>

        <ConfirmAction
            options={confirmOptions}
            setOptions={setConfirmOptions}
        />

        <style jsx>{`
            
        `}</style>
    </>);
};

export default EditSignatureTemplate;

export const Route = createFileRoute('/_authenticated/settings/signaturetemplate/$id')({ component: EditSignatureTemplate })
